import { LngLat } from 'maplibre-gl';
import config from '../../../config';
import axios from 'axios';
function checkAndnormalizeOpt(opt) {
    if (!Array.isArray(opt.origins) || opt.origins.length === 0) {
        throw new Error('origin is required in DistanceMatrixRequest');
    }
    if (!Array.isArray(opt.destinations) || opt.destinations.length === 0) {
        throw new Error('destination is required in DistanceMatrixRequest');
    }
    const nOpt = Object.assign({}, opt, {
        origin: opt.origins.map((origin) => LngLat.convert(origin)),
        destination: opt.destinations.map((destination) => LngLat.convert(destination)),
    });
    return nOpt;
}
export class DistanceMatrixService {
    async getDistanceMatrix(opt) {
        const nOpt = checkAndnormalizeOpt(opt);
        if (!config.API_KEY) {
            throw new Error('In order to call the NextBillion.ai API, you must provide a valid API Key.');
        }
        if (!config.API_HOST) {
            throw new Error('An API host is required to make request to NextBillion.ai API.');
        }
        const params = {
            key: config.API_KEY,
            origins: nOpt.origins.map((origin) => `${origin.lat},${origin.lng}`).join('|'),
            destinations: nOpt.destinations.map((dest) => `${dest.lat},${dest.lng}`).join('|'),
        };
        if (!nOpt.departureTime || (typeof nOpt.departureTime === 'string' && isNaN(parseInt(nOpt.departureTime)))) {
            nOpt.departureTime = 0;
        }
        params.departure_time = nOpt.departureTime;
        if (nOpt.avoid) {
            params.avoid = nOpt.avoid;
        }
        if (nOpt.mode) {
            params.mode = nOpt.mode;
        }
        if (nOpt.approaches) {
            params.approaches = nOpt.approaches.join(';');
        }
        return axios
            .get(`https://${config.API_HOST}/distancematrix/json`, {
            params,
        })
            .then((resp) => resp.data)
            .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            else {
                return err;
            }
        });
    }
}
//# sourceMappingURL=distance-matrix.js.map